import { render, staticRenderFns } from "./InteractiveImage_Label_Transfer.vue?vue&type=template&id=7d7df6b8&"
import script from "./InteractiveImage_Label_Transfer.vue?vue&type=script&lang=js&"
export * from "./InteractiveImage_Label_Transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports